export class BinFileState {
    loading = false;
    record: any = {};
}
